import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgMaterialModule } from '@principle-theorem/ng-material';
import { NgPrincipleSharedModule } from '@principle-theorem/ng-principle-shared';
import {
  NgSharedModule,
  TypedFormControl,
  TypedFormGroup,
} from '@principle-theorem/ng-shared';
import { IBigQueryUploadsConfig } from '@principle-theorem/principle-core/interfaces';

@Component({
  selector: 'pr-big-query-uploads-config',
  templateUrl: './big-query-uploads-config.component.html',
  styleUrls: ['./big-query-uploads-config.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    NgMaterialModule,
    NgSharedModule,
    NgPrincipleSharedModule,
  ],
})
export class BigQueryUploadsConfigComponent {
  private _dialogRef =
    inject<
      MatDialogRef<
        BigQueryUploadsConfigComponent,
        Partial<IBigQueryUploadsConfig>
      >
    >(MatDialogRef);
  private _data = inject<IBigQueryUploadsConfig>(MAT_DIALOG_DATA);
  form = new TypedFormGroup<Partial<IBigQueryUploadsConfig>>({
    dryRun: new TypedFormControl<boolean>(false),
    maxJobs: new TypedFormControl<number>(0, Validators.min(1)),
    maxJobSize: new TypedFormControl<number>(0, Validators.min(1)),
    enableTimingLogs: new TypedFormControl<boolean>(false),
  });

  constructor() {
    this.form.patchValue(this._data);
  }

  onSubmit(): void {
    if (this.form.invalid) {
      return;
    }
    this._dialogRef.close(this.form.value);
  }
}
